<mat-form-field class="mat-form-field-dense no-theme menu-select" [style.maxWidth]="maxWidth">
    <mat-select
        title="{{ disabled ? '' : tooltip }}"
        panelClass="se-mat-select-panel-class se-mat-text-editor-menu-select"
        [ngModel]="value"
        [disabled]="disabled"
        [disableOptionCentering]="true"
        (ngModelChange)="onSelectionChange($event)"
    >
        <mat-option class="mat-option" *ngFor="let item of items" [value]="item.toLowerCase()">
            {{ item }}
        </mat-option>
    </mat-select>
</mat-form-field>
